import { render, staticRenderFns } from "./assign-room-modal.vue?vue&type=template&id=94188cea&scoped=true"
import script from "./assign-room-modal.vue?vue&type=script&lang=js"
export * from "./assign-room-modal.vue?vue&type=script&lang=js"
import style0 from "./assign-room-modal.vue?vue&type=style&index=0&id=94188cea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94188cea",
  null
  
)

export default component.exports